import React from "react";
import { ReactComponent as TekkrLogoLight } from "../../../static/tekkr-logo-script-light.svg";
import { ReactComponent as TekkrLogoDark } from "../../../static/tekkr-logo-script-dark.svg";
import { ReactComponent as _TekkrIcon } from "../../../static/tekkr-icon.svg";
import { useColorScheme } from "../../../lib/color-scheme";
import { cn } from "../../../lib/utils";

export function TekkrLogo(props: React.SVGProps<SVGSVGElement> & { forceScheme?: "dark" | "light" }) {
    const { isDark } = useColorScheme();
    if (props.forceScheme) {
        return props.forceScheme === "dark" ? <TekkrLogoDark {...props} /> : <TekkrLogoLight {...props} />;
    }
    return isDark ? <TekkrLogoDark {...props} /> : <TekkrLogoLight {...props} />;
}

export function TekkrIcon(props: React.SVGProps<SVGSVGElement> & { color?: string }) {
    // eslint-disable-next-line react/prop-types
    const className = props.className;
    return <_TekkrIcon {...props} className={cn(className, props.color && `[&_path]:fill-${props.color}`)} />;
}
